module.exports = __webpack_public_path__ + "static/media/3.11.a6be1596.png";